export default __webpack_public_path__ + "static/service3-33b5616d69aed7519dc3a401e1bfe6a5.png";